import KanbanPhase from '@/lib/constants/KanbanPhase.enum';
import useTaskPhaseDrop from './useTaskPhaseDrop';
import PhaseColumn from '../../ChallengeBoard/KanbanPhaseColumn/PhaseColumn';
import PhaseContext from '../../PhaseContext';
import CreateTask from './CreateTask';
import Task from '../../Task';
import ResponsiveMasonry from '../../ChallengeBoard/KanbanPhaseColumn/ResponsiveMasonry';
import { type TaskSummary } from '@/lib/types';
import React from 'react';
import reverseSortByCreatedAt from '@/lib/utils/sorting/reverseSortByCreatedAt';

type KanbanPhaseColumnProps = {
  phase: KanbanPhase;
  tasks: TaskSummary[];
};

const KanbanPhaseColumn = ({ phase, tasks }: KanbanPhaseColumnProps) => {
  const attachDropHandlingRef = useTaskPhaseDrop(phase);

  return (
    <PhaseContext.Provider value={phase}>
      <PhaseColumn
        hasItems={tasks.length > 0}
        ref={attachDropHandlingRef as unknown as React.Ref<HTMLDivElement>}
        inTaskBoard
      >
        <ResponsiveMasonry widthDenominator={600}>
          {tasks.sort(reverseSortByCreatedAt).map(task => (
            <Task task={task} key={task.id} />
          ))}
        </ResponsiveMasonry>
        {phase === KanbanPhase.TODO && <CreateTask />}
      </PhaseColumn>
    </PhaseContext.Provider>
  );
};

export default KanbanPhaseColumn;
